import { createFileRoute } from '@tanstack/react-router';
import { BroadcastPage } from '../../features/B2b/broadcast-page';

/** Task 23 — "הודעת תפוצה" (lane B2b): one message to every group of the selected clients, through the outbox. */
export const Route = createFileRoute('/_app/broadcast')({
  component: BroadcastPage,
});
